
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'page-details-ui',
  currentProjectVersion: 'static-1.20712',
  depVersions: {
  "page-details-ui": "static-1.20712",
  "ai-components-ui-library": "static-1.7349",
  "apollo-dlb": "static-3.73",
  "apollo-stack-hubspot": "static-3.69",
  "billing-management-service-client": "static-1.6401",
  "content-management-data-lib": "static-1.4544",
  "content-management-details-lib": "static-1.28478",
  "content-management-restrictions-lib": "static-1.4320",
  "crm-object-map": "static-1.4341",
  "data-fetching-client": "static-1.9038",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1427",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4360",
  "highcharts": "static-8.89",
  "history": "static-4.47",
  "hs-test-utils": "static-1.7357",
  "hub-http": "static-1.5499",
  "hub-http-shared-msw-handlers": "static-1.8480",
  "hubspot-dlb": "static-2.1707",
  "HubStyleTokens": "static-2.10882",
  "I18n": "static-7.1455",
  "jasmine-runner": "static-1.5784",
  "page-lib": "static-1.20660",
  "quartz": "static-1.6182",
  "react-dlb": "static-1.62",
  "react-dnd": "static-2.33",
  "react-dnd-html5-backend": "static-2.10",
  "react-router-dom": "static-5.26",
  "reporting-data": "static-1.64993",
  "reporting-dlb": "static-1.57911",
  "reporting-testing-lib": "static-1.6927",
  "reporting-visualizations": "static-1.57070",
  "settings-ui-lib": "static-1.11895",
  "ui-addon-draggable": "static-1.4374",
  "video-reports-lib": "static-1.33304",
  "webpack-env": "static-1.54",
  "amplitude-session-replay-browser": "static-1.45",
  "analytics-tools-lib": "static-1.74994",
  "asset-actions-lib": "static-1.44356",
  "attribution-lib": "static-1.40791",
  "campaigns-lib": "static-1.25458",
  "collaboration-sidebar": "static-1.56187",
  "content-intel-content-details-optimize-panel": "static-1.7740",
  "content-management-actions-lib": "static-1.25985",
  "ContentComponents": "static-2.69376",
  "ContentData": "static-1.66495",
  "ContentUtils": "static-1.66420",
  "customer-data-objects": "static-1.7013",
  "customer-data-properties": "static-1.49579",
  "customer-data-property-utils": "static-1.7339",
  "customer-data-reference-ui-components": "static-1.12441",
  "error-messaging-js": "static-1.4642",
  "ExportDialog": "static-6.9839",
  "file-manager-components": "static-1.21831",
  "foundations-assets": "static-1.4223",
  "foundations-components": "static-1.6885",
  "foundations-theming": "static-1.3711",
  "hubspot-apollo-client": "static-1.4195",
  "hubspot-url-utils": "static-1.3531",
  "immutable": "static-2.19",
  "marketing-contacts-lib": "static-1.8609",
  "marketing-discovery-utils": "static-1.4408",
  "object-builder-ui-client": "static-1.46724",
  "onboarding-tours": "static-1.15788",
  "PortalIdParser": "static-2.306",
  "property-translator": "static-1.4735",
  "quartz-core": "static-1.5401",
  "quick-fetch": "static-1.3394",
  "react": "static-7.151",
  "react-dom": "static-7.85",
  "react-redux": "static-7.16",
  "react-rhumb": "static-1.15976",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reporting-action-components": "static-1.39643",
  "reporting-plugins": "static-1.9337",
  "reporting-ui-components": "static-2.62267",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4065",
  "sanitize-text": "static-1.7522",
  "segments-lib": "static-1.31002",
  "SharedI18nStrings": "static-1.171",
  "social-composer-lib": "static-1.56657",
  "ui-addon-emoji-picker": "static-1.9300",
  "ui-addon-form-validation": "static-1.10393",
  "ui-addon-i18n": "static-1.10359",
  "ui-addon-iframeable": "static-1.8290",
  "ui-addon-react-router-dom": "static-1.8968",
  "ui-addon-teams": "static-1.20724",
  "ui-addon-upgrades": "static-9.16994",
  "ui-asset-management-lib": "static-1.10087",
  "ui-business-units-lib": "static-1.8296",
  "ui-forms-editor-automation-lib": "static-1.62457",
  "ui-memberships-settings-lib": "static-1.32206",
  "ui-product-approvals": "static-1.26343",
  "ui-shepherd-react": "static-3.9436",
  "UIComponents": "static-3.7829",
  "usage-tracker": "static-1.6794",
  "usage-tracker-container": "static-1.6784",
  "usage-tracker-core": "static-1.6644",
  "usage-tracker-session-replay": "static-1.4480",
  "enviro": "static-4.328",
  "hs-promise-rejection-tracking": "static-1.4750",
  "raven": "static-3.5229",
  "raven-hubspot": "static-1.5536",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9058",
  "styled-components": "static-2.64",
  "bend-plugin-trellis-migration": "static-1.2894",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2459",
  "quartz-webpack": "static-1.2406",
  "autolinker": "static-3.11",
  "chatspot-client-types": "static-1.10068",
  "chatspot-core": "static-1.18969",
  "copilot-toolkit": "static-1.9492",
  "cssUtils": "static-1.605",
  "foundations-theming-base": "static-1.2696",
  "hs-story-utils": "static-1.8734",
  "HubStyle": "static-2.11190",
  "icons": "static-2.596",
  "msw": "static-1.39",
  "react-utils": "static-2.4749",
  "sanitize": "static-1.3748",
  "sassPrefix": "static-1.142",
  "ui-fonts": "static-1.334",
  "ui-images": "static-2.970",
  "graphql": "static-1.67",
  "react-dnd-compat": "static-1.4037",
  "report-customization-components": "static-1.11573",
  "reporting-enablement": "static-1.20848",
  "avatar-components": "static-1.1846",
  "crm-fe-perf": "static-1.22329",
  "crm-index-visualization-object-layout": "static-1.4005",
  "crm-links": "static-1.5562",
  "crm-message-bus": "static-1.41288",
  "crm-object-search-query-utilities": "static-1.8296",
  "feedback-loader": "static-1.28054",
  "framework-data-schema-resolvers": "static-1.6261",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.8563",
  "inbound-db-meta-service-client": "static-1.3145",
  "transmute": "static-2.77",
  "directed-graph": "static-1.301",
  "event-emitter": "static-1.364",
  "fast-json-stable-stringify": "static-1.4",
  "HeadJS": "static-2.625",
  "framer-motion": "static-1.53",
  "hs-test-utils-bend-plugin": "static-1.2468",
  "testing-library": "static-1.135",
  "ts-schema": "static-1.3538",
  "i18n-data": "static-1.208",
  "moment-timezone": "static-5.68",
  "jasmine": "static-4.3676",
  "redux-toolkit": "static-1.7",
  "quartz-core-utils": "static-1.3049",
  "StyleGuideUI": "static-3.476",
  "frontend-preferences-client": "static-1.7304",
  "immer": "static-1.33",
  "reference-resolvers": "static-1.7540",
  "reporting-client-types": "static-1.2258",
  "hs-lodash": "static-4.45",
  "react-immutable-proptypes": "static-2.8",
  "flux-actions": "static-1.287",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.9625",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.9832",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "react-flip-move": "static-1.55",
  "marketing-platform-lib": "static-1.6139",
  "react-input-autosize": "static-2.17",
  "user-context": "static-1.4556",
  "atom": "static-1.4515",
  "customer-data-filters-ui": "static-1.37530",
  "FormUrlGenerator": "static-2.4069",
  "integrations-lib": "static-1.14260",
  "property-description-translator": "static-1.3187",
  "reference-resolvers-lite": "static-1.7422",
  "reporting-snowflake": "static-1.53613",
  "self-service-api": "static-1.9620",
  "crm-pipelines-api-client-types": "static-1.3511",
  "customer-data-objects-ui-components": "static-1.12347",
  "hs-promise-utils": "static-1.4896",
  "superstore": "static-1.4084",
  "ui-addon-opt": "static-4.7864",
  "chatspot-widget-iframe": "static-1.18961",
  "collaboration-sidebar-common": "static-1.983",
  "magpie-lib": "static-1.5016",
  "magpie-types": "static-1.4476",
  "simple-logging-lib": "static-1.2359",
  "content-intel-shared": "static-1.8016",
  "advanced-menus-core": "static-1.14215",
  "advanced-menus-lib": "static-1.11272",
  "blueimp-md5": "static-1.8",
  "cms-field-types": "static-1.4120",
  "codemirror": "static-5.80",
  "content-embed-lib": "static-1.6709",
  "data-token-picker": "static-1.15395",
  "data-token-views": "static-1.15376",
  "FileManagerCore": "static-1.37330",
  "FileManagerLib": "static-1.37471",
  "forms-utils-lib": "static-1.11417",
  "growth-payments-core": "static-1.23616",
  "integrations-error-boundary-lib": "static-1.11675",
  "media-bridge-lib": "static-1.17977",
  "payment-link-components": "static-1.21958",
  "payments-embed-points-lib": "static-1.11723",
  "products-iframe-lib": "static-1.6310",
  "products-ui-components": "static-1.38207",
  "react-beautiful-dnd": "static-1.13",
  "react-codemirror": "static-1.9976",
  "react-select-plus": "static-1.65",
  "react-tinymce": "static-1.53529",
  "react-virtualized": "static-2.82",
  "rich-text-lib": "static-1.18741",
  "simple-menus-core": "static-1.14214",
  "simple-menus-lib": "static-1.15731",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.52655",
  "tinymce-data": "static-1.38740",
  "tinymce-plugins": "static-1.55769",
  "tinymce-themes": "static-1.54625",
  "video-data-lib": "static-1.33128",
  "videoconference-integration-components": "static-1.5919",
  "content-icons-ui": "static-1.2020",
  "inbound-db-properties-service-client": "static-1.3366",
  "calling-cross-tab-library": "static-1.18659",
  "calling-global-api": "static-1.62387",
  "calling-integration-cross-tab": "static-1.21445",
  "calling-internal-common": "static-1.30661",
  "calling-lifecycle-internal": "static-1.63769",
  "calling-lifecycle-messages": "static-1.56063",
  "commerce-products-lib": "static-1.7687",
  "conditional-properties-service-client": "static-1.3326",
  "external-options-client-types": "static-1.3534",
  "google-libphonenumber": "static-1.21",
  "inbounddb-objects-service-types": "static-1.3637",
  "pipeline-validation-client-types": "static-1.3331",
  "property-value-citations": "static-1.193",
  "smart-property-lib": "static-1.4525",
  "tiered-pricing": "static-1.274",
  "customer-data-ui-utilities": "static-1.9141",
  "apollo-link-hub-http": "static-2.4094",
  "immerable": "static-1.3478",
  "video-components-external": "static-1.9470",
  "bend-plugin-foundations-components": "static-1.3154",
  "floating-ui": "static-1.41",
  "react-aria": "static-1.44",
  "tanstack-table": "static-1.23",
  "bend-plugin-foundations-theming": "static-1.2194",
  "foundations-components-test-utils": "static-1.4369",
  "getting-started-shared-tasks": "static-1.16780",
  "growth-data-modal": "static-1.4680",
  "growth-onboarding-confetti": "static-1.2443",
  "growth-onboarding-next-action-utils": "static-1.786",
  "navigation-components": "static-1.16225",
  "ui-shepherd-tracker": "static-1.6817",
  "ui-universal-auth": "static-1.8236",
  "dispatcher": "static-1.122",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.702",
  "hubspotter-http": "static-1.4010",
  "hubspotter-http-shared-msw-handlers": "static-1.8478",
  "mobile-manifest-mixins": "static-1.397",
  "platform-navigation-bootstrap": "static-1.11882",
  "csstype": "static-1.50",
  "content-assistance-lib": "static-1.7002",
  "dashboard-lib": "static-1.79201",
  "hubspot-prosemirror": "static-1.16544",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8073",
  "campaign-roi-lib": "static-1.7118",
  "reporting-reports": "static-1.64673",
  "navigation-messaging": "static-1.5552",
  "feature-store-service-types": "static-1.4016",
  "growth-monetization-service-types": "static-1.4023",
  "merchandise-lib": "static-1.237",
  "salesImages": "static-1.511",
  "upgrade-management-service-types": "static-1.4007",
  "timezone-utils": "static-2.4565",
  "automation-contextual-components": "static-1.15426",
  "automation-ui-source-apps": "static-1.16976",
  "automation-ui-template": "static-1.44943",
  "automation-ui-types": "static-1.17894",
  "forms-ai-lib": "static-1.3146",
  "redux-actions": "static-3.7",
  "ui-addon-automation-embed": "static-1.13321",
  "ui-forms-components": "static-1.9412",
  "bender-build-tools": "static-1.2538",
  "markdown-it": "static-1.6",
  "conversations-skeleton-state": "static-1.6732",
  "data-quality-ui-library": "static-1.11340",
  "html-to-image": "static-1.38",
  "laboratory-lib": "static-3.6555",
  "zustand": "static-1.51",
  "location-customization-utils-lib": "static-1.7352",
  "hs-entities": "static-1.11",
  "batch-promise": "static-1.962",
  "framework-builder-read-service-client": "static-1.3486",
  "framework-data-schema-quick-fetch": "static-1.6166",
  "persist-promise": "static-1.3120",
  "getting-started-shared-tasks-store": "static-1.15898",
  "customer-data-filters-ui-msw-helpers": "static-1.19964",
  "lodash": "static-4.7",
  "multi-account-reference-resolvers": "static-1.381",
  "integrations-tracking-lib": "static-1.5017",
  "native-integrations-shared-strings": "static-1.7171",
  "reporting-datasets-permissions-lib": "static-1.11783",
  "idb-keyval": "static-1.29",
  "reactive-lib": "static-1.108",
  "seamless-immutable": "static-7.6",
  "diff-match-patch": "static-1.7",
  "audio-components": "static-1.5145",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.34982",
  "urlinator": "static-1.3908",
  "video-components": "static-1.11473",
  "video-embed": "static-1.33962",
  "commerce-analytics-service-client": "static-1.3024",
  "onboarding-scopes": "static-1.5882",
  "commerce-tours-lib": "static-1.5104",
  "growth-onboarding-reliability": "static-1.4491",
  "sales-checkout-service-client": "static-1.3036",
  "payments-enrollment-embed-lib": "static-1.20705",
  "commerce-shared-components-lib": "static-1.16916",
  "commerce-subscription-lib": "static-1.35360",
  "crm_components": "static-3.90032",
  "crm_data": "static-4.90032",
  "customer-data-tracking": "static-1.6216",
  "framework-data-table": "static-2.10557",
  "browser-eslint": "static-2.57",
  "hub-http-contrib": "static-1.2468",
  "interframe": "static-3.4129",
  "ui-addon-sales-email": "static-1.4570",
  "layout-dnd-components": "static-1.11378",
  "layout-dnd-utils": "static-1.10353",
  "ui-brand-identity-lib": "static-1.12279",
  "NamespacedHubStyle": "static-2.8617",
  "shared-worker-versioning": "static-1.10440",
  "calling-error-reporting": "static-1.30667",
  "worker-connection-library": "static-1.15921",
  "calling-usage-tracker": "static-1.5865",
  "calling-orchestration-shared-library": "static-1.33592",
  "react-immutable-render-mixin": "static-1.9",
  "products-ui-components-shared-msw-handlers": "static-1.8862",
  "breeze-intelligence-kit": "static-1.4716",
  "fsm": "static-1.3062",
  "policy-lib": "static-1.6128",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.8626",
  "content-media-composition-data-lib": "static-1.9724",
  "content-media-compositions": "static-2.13731",
  "platform-infra-nav-components": "static-1.7120",
  "react-transition-group": "static-1.7",
  "ui-addon-video-player": "static-1.8118",
  "ui-coaching-tips": "static-1.26780",
  "knowledge-content-types": "static-1.8041",
  "automation-platform-service-types": "static-1.2326",
  "automation-templates-service-types": "static-1.3317",
  "automation-ui-core": "static-2.19830",
  "automation-ui-routing": "static-1.19253",
  "automation-ui-usage-tracker": "static-1.512",
  "final-form": "static-1.53",
  "redux-mock-store": "static-1.8",
  "form-builder-ui": "static-1.8594",
  "crm-record-cards-service-types": "static-1.3103",
  "universal-page-editor-lib": "static-1.2416",
  "social-insights-client-types": "static-1.20339",
  "outpost": "static-1.3683",
  "onboarding-tours-client": "static-1.4002",
  "growth-onboarding-feedback-components": "static-1.5866",
  "marketplace-ui-apps-core": "static-1.16409",
  "stripe-embedded-components": "static-1.6524",
  "customer-data-associations": "static-1.6599",
  "commerce-billing-lib": "static-1.17447",
  "commerce-tools-ui-lib": "static-1.8948",
  "crm_universal": "static-1.21182",
  "customer-data-content": "static-1.26121",
  "crm_schema": "static-3.90071",
  "customer-data-email": "static-1.16962",
  "layout-data-lib": "static-1.8678",
  "calling-orchestration-schema": "static-1.33817",
  "multi-currency-client-types": "static-1.3147",
  "sales-views-client-types": "static-1.3626",
  "trellis-story-utils": "static-1.3913",
  "storybook-react": "static-1.16",
  "hls.js": "static-1.24",
  "js-cookie": "static-1.18",
  "immutable-less": "static-1.3930",
  "usage-tracker-hubtools": "static-1.6786",
  "developer-experience-shared-components": "static-1.9720",
  "marketplace-ui-client-types": "static-1.15282",
  "marketplace-ui-common": "static-1.17875",
  "ui-addon-integrations-directory-panel": "static-2.7422",
  "ui-extensibility-client-types": "static-1.3407",
  "stripe-connect-js": "static-1.43",
  "utility-belt": "static-1.1863",
  "customer-data-rte": "static-1.31578",
  "cv-backend-services": "static-1.1349",
  "growth-onboarding-empty-states": "static-1.4887",
  "InboxConnectUtils": "static-4.13250",
  "payments-post-enroll-local-storage-lib": "static-1.4437",
  "qrcode-generator": "static-1.52",
  "quotes-client-types": "static-1.35899",
  "trials-service-types": "static-1.3424",
  "SalesContentIndexUI": "static-3.8184",
  "sequences-lib": "static-1.7132",
  "ui-gdpr-components": "static-1.9601",
  "apps-service-types": "static-1.3350",
  "oauth-service-types": "static-1.3610",
  "ai-settings-ui-library": "static-1.6746",
  "nav-meta": "static-1.27862",
  "react-window": "static-1.13",
  "draft-content-plugins": "static-1.26926",
  "draft-convert": "static-2.31",
  "draft-extend": "static-2.46",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.20601",
  "FireAlarmUi": "static-1.4034",
  "sales-templates-service-types-lib": "static-1.3596",
  "sequences-client-types-lib": "static-1.6989"
},
  depPathPrefixes: {
  "page-details-ui": "/page-details-ui/static-1.20712",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.7349",
  "apollo-dlb": "/apollo-dlb/static-3.73",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.69",
  "billing-management-service-client": "/billing-management-service-client/static-1.6401",
  "content-management-data-lib": "/content-management-data-lib/static-1.4544",
  "content-management-details-lib": "/content-management-details-lib/static-1.28478",
  "content-management-restrictions-lib": "/content-management-restrictions-lib/static-1.4320",
  "crm-object-map": "/crm-object-map/static-1.4341",
  "data-fetching-client": "/data-fetching-client/static-1.9038",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1427",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4360",
  "highcharts": "/highcharts/static-8.89",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.7357",
  "hub-http": "/hub-http/static-1.5499",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8480",
  "hubspot-dlb": "/hubspot-dlb/static-2.1707",
  "HubStyleTokens": "/HubStyleTokens/static-2.10882",
  "I18n": "/I18n/static-7.1455",
  "jasmine-runner": "/jasmine-runner/static-1.5784",
  "page-lib": "/page-lib/static-1.20660",
  "quartz": "/quartz/static-1.6182",
  "react-dlb": "/react-dlb/static-1.62",
  "react-dnd": "/react-dnd/static-2.33",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reporting-data": "/reporting-data/static-1.64993",
  "reporting-dlb": "/reporting-dlb/static-1.57911",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.6927",
  "reporting-visualizations": "/reporting-visualizations/static-1.57070",
  "settings-ui-lib": "/settings-ui-lib/static-1.11895",
  "ui-addon-draggable": "/ui-addon-draggable/static-1.4374",
  "video-reports-lib": "/video-reports-lib/static-1.33304",
  "webpack-env": "/webpack-env/static-1.54",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.45",
  "analytics-tools-lib": "/analytics-tools-lib/static-1.74994",
  "asset-actions-lib": "/asset-actions-lib/static-1.44356",
  "attribution-lib": "/attribution-lib/static-1.40791",
  "campaigns-lib": "/campaigns-lib/static-1.25458",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.56187",
  "content-intel-content-details-optimize-panel": "/content-intel-content-details-optimize-panel/static-1.7740",
  "content-management-actions-lib": "/content-management-actions-lib/static-1.25985",
  "ContentComponents": "/ContentComponents/static-2.69376",
  "ContentData": "/ContentData/static-1.66495",
  "ContentUtils": "/ContentUtils/static-1.66420",
  "customer-data-objects": "/customer-data-objects/static-1.7013",
  "customer-data-properties": "/customer-data-properties/static-1.49579",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7339",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12441",
  "error-messaging-js": "/error-messaging-js/static-1.4642",
  "ExportDialog": "/ExportDialog/static-6.9839",
  "file-manager-components": "/file-manager-components/static-1.21831",
  "foundations-assets": "/foundations-assets/static-1.4223",
  "foundations-components": "/foundations-components/static-1.6885",
  "foundations-theming": "/foundations-theming/static-1.3711",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4195",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3531",
  "immutable": "/immutable/static-2.19",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.8609",
  "marketing-discovery-utils": "/marketing-discovery-utils/static-1.4408",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.46724",
  "onboarding-tours": "/onboarding-tours/static-1.15788",
  "PortalIdParser": "/PortalIdParser/static-2.306",
  "property-translator": "/property-translator/static-1.4735",
  "quartz-core": "/quartz-core/static-1.5401",
  "quick-fetch": "/quick-fetch/static-1.3394",
  "react": "/react/static-7.151",
  "react-dom": "/react-dom/static-7.85",
  "react-redux": "/react-redux/static-7.16",
  "react-rhumb": "/react-rhumb/static-1.15976",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reporting-action-components": "/reporting-action-components/static-1.39643",
  "reporting-plugins": "/reporting-plugins/static-1.9337",
  "reporting-ui-components": "/reporting-ui-components/static-2.62267",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4065",
  "sanitize-text": "/sanitize-text/static-1.7522",
  "segments-lib": "/segments-lib/static-1.31002",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.171",
  "social-composer-lib": "/social-composer-lib/static-1.56657",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9300",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10393",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10359",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8290",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8968",
  "ui-addon-teams": "/ui-addon-teams/static-1.20724",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.16994",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10087",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8296",
  "ui-forms-editor-automation-lib": "/ui-forms-editor-automation-lib/static-1.62457",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.32206",
  "ui-product-approvals": "/ui-product-approvals/static-1.26343",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9436",
  "UIComponents": "/UIComponents/static-3.7829",
  "usage-tracker": "/usage-tracker/static-1.6794",
  "usage-tracker-container": "/usage-tracker-container/static-1.6784",
  "usage-tracker-core": "/usage-tracker-core/static-1.6644",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4480",
  "enviro": "/enviro/static-4.328",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4750",
  "raven": "/raven/static-3.5229",
  "raven-hubspot": "/raven-hubspot/static-1.5536",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9058",
  "styled-components": "/styled-components/static-2.64",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2894",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2459",
  "quartz-webpack": "/quartz-webpack/static-1.2406",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-client-types": "/chatspot-client-types/static-1.10068",
  "chatspot-core": "/chatspot-core/static-1.18969",
  "copilot-toolkit": "/copilot-toolkit/static-1.9492",
  "cssUtils": "/cssUtils/static-1.605",
  "foundations-theming-base": "/foundations-theming-base/static-1.2696",
  "hs-story-utils": "/hs-story-utils/static-1.8734",
  "HubStyle": "/HubStyle/static-2.11190",
  "icons": "/icons/static-2.596",
  "msw": "/msw/static-1.39",
  "react-utils": "/react-utils/static-2.4749",
  "sanitize": "/sanitize/static-1.3748",
  "sassPrefix": "/sassPrefix/static-1.142",
  "ui-fonts": "/ui-fonts/static-1.334",
  "ui-images": "/ui-images/static-2.970",
  "graphql": "/graphql/static-1.67",
  "react-dnd-compat": "/react-dnd-compat/static-1.4037",
  "report-customization-components": "/report-customization-components/static-1.11573",
  "reporting-enablement": "/reporting-enablement/static-1.20848",
  "avatar-components": "/avatar-components/static-1.1846",
  "crm-fe-perf": "/crm-fe-perf/static-1.22329",
  "crm-index-visualization-object-layout": "/crm-index-visualization-object-layout/static-1.4005",
  "crm-links": "/crm-links/static-1.5562",
  "crm-message-bus": "/crm-message-bus/static-1.41288",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.8296",
  "feedback-loader": "/feedback-loader/static-1.28054",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6261",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.8563",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3145",
  "transmute": "/transmute/static-2.77",
  "directed-graph": "/directed-graph/static-1.301",
  "event-emitter": "/event-emitter/static-1.364",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "HeadJS": "/HeadJS/static-2.625",
  "framer-motion": "/framer-motion/static-1.53",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2468",
  "testing-library": "/testing-library/static-1.135",
  "ts-schema": "/ts-schema/static-1.3538",
  "i18n-data": "/i18n-data/static-1.208",
  "moment-timezone": "/moment-timezone/static-5.68",
  "jasmine": "/jasmine/static-4.3676",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "quartz-core-utils": "/quartz-core-utils/static-1.3049",
  "StyleGuideUI": "/StyleGuideUI/static-3.476",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7304",
  "immer": "/immer/static-1.33",
  "reference-resolvers": "/reference-resolvers/static-1.7540",
  "reporting-client-types": "/reporting-client-types/static-1.2258",
  "hs-lodash": "/hs-lodash/static-4.45",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "flux-actions": "/flux-actions/static-1.287",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.9625",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.9832",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "react-flip-move": "/react-flip-move/static-1.55",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6139",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "user-context": "/user-context/static-1.4556",
  "atom": "/atom/static-1.4515",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.37530",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4069",
  "integrations-lib": "/integrations-lib/static-1.14260",
  "property-description-translator": "/property-description-translator/static-1.3187",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7422",
  "reporting-snowflake": "/reporting-snowflake/static-1.53613",
  "self-service-api": "/self-service-api/static-1.9620",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3511",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12347",
  "hs-promise-utils": "/hs-promise-utils/static-1.4896",
  "superstore": "/superstore/static-1.4084",
  "ui-addon-opt": "/ui-addon-opt/static-4.7864",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.18961",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.983",
  "magpie-lib": "/magpie-lib/static-1.5016",
  "magpie-types": "/magpie-types/static-1.4476",
  "simple-logging-lib": "/simple-logging-lib/static-1.2359",
  "content-intel-shared": "/content-intel-shared/static-1.8016",
  "advanced-menus-core": "/advanced-menus-core/static-1.14215",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11272",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "cms-field-types": "/cms-field-types/static-1.4120",
  "codemirror": "/codemirror/static-5.80",
  "content-embed-lib": "/content-embed-lib/static-1.6709",
  "data-token-picker": "/data-token-picker/static-1.15395",
  "data-token-views": "/data-token-views/static-1.15376",
  "FileManagerCore": "/FileManagerCore/static-1.37330",
  "FileManagerLib": "/FileManagerLib/static-1.37471",
  "forms-utils-lib": "/forms-utils-lib/static-1.11417",
  "growth-payments-core": "/growth-payments-core/static-1.23616",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.11675",
  "media-bridge-lib": "/media-bridge-lib/static-1.17977",
  "payment-link-components": "/payment-link-components/static-1.21958",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.11723",
  "products-iframe-lib": "/products-iframe-lib/static-1.6310",
  "products-ui-components": "/products-ui-components/static-1.38207",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "react-codemirror": "/react-codemirror/static-1.9976",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-tinymce": "/react-tinymce/static-1.53529",
  "react-virtualized": "/react-virtualized/static-2.82",
  "rich-text-lib": "/rich-text-lib/static-1.18741",
  "simple-menus-core": "/simple-menus-core/static-1.14214",
  "simple-menus-lib": "/simple-menus-lib/static-1.15731",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.52655",
  "tinymce-data": "/tinymce-data/static-1.38740",
  "tinymce-plugins": "/tinymce-plugins/static-1.55769",
  "tinymce-themes": "/tinymce-themes/static-1.54625",
  "video-data-lib": "/video-data-lib/static-1.33128",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.5919",
  "content-icons-ui": "/content-icons-ui/static-1.2020",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3366",
  "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18659",
  "calling-global-api": "/calling-global-api/static-1.62387",
  "calling-integration-cross-tab": "/calling-integration-cross-tab/static-1.21445",
  "calling-internal-common": "/calling-internal-common/static-1.30661",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.63769",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56063",
  "commerce-products-lib": "/commerce-products-lib/static-1.7687",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3326",
  "external-options-client-types": "/external-options-client-types/static-1.3534",
  "google-libphonenumber": "/google-libphonenumber/static-1.21",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3637",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3331",
  "property-value-citations": "/property-value-citations/static-1.193",
  "smart-property-lib": "/smart-property-lib/static-1.4525",
  "tiered-pricing": "/tiered-pricing/static-1.274",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9141",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4094",
  "immerable": "/immerable/static-1.3478",
  "video-components-external": "/video-components-external/static-1.9470",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3154",
  "floating-ui": "/floating-ui/static-1.41",
  "react-aria": "/react-aria/static-1.44",
  "tanstack-table": "/tanstack-table/static-1.23",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2194",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4369",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.16780",
  "growth-data-modal": "/growth-data-modal/static-1.4680",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2443",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.786",
  "navigation-components": "/navigation-components/static-1.16225",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6817",
  "ui-universal-auth": "/ui-universal-auth/static-1.8236",
  "dispatcher": "/dispatcher/static-1.122",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.702",
  "hubspotter-http": "/hubspotter-http/static-1.4010",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8478",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.397",
  "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11882",
  "csstype": "/csstype/static-1.50",
  "content-assistance-lib": "/content-assistance-lib/static-1.7002",
  "dashboard-lib": "/dashboard-lib/static-1.79201",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.16544",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8073",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.7118",
  "reporting-reports": "/reporting-reports/static-1.64673",
  "navigation-messaging": "/navigation-messaging/static-1.5552",
  "feature-store-service-types": "/feature-store-service-types/static-1.4016",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4023",
  "merchandise-lib": "/merchandise-lib/static-1.237",
  "salesImages": "/salesImages/static-1.511",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4007",
  "timezone-utils": "/timezone-utils/static-2.4565",
  "automation-contextual-components": "/automation-contextual-components/static-1.15426",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.16976",
  "automation-ui-template": "/automation-ui-template/static-1.44943",
  "automation-ui-types": "/automation-ui-types/static-1.17894",
  "forms-ai-lib": "/forms-ai-lib/static-1.3146",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-automation-embed": "/ui-addon-automation-embed/static-1.13321",
  "ui-forms-components": "/ui-forms-components/static-1.9412",
  "bender-build-tools": "/bender-build-tools/static-1.2538",
  "markdown-it": "/markdown-it/static-1.6",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6732",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.11340",
  "html-to-image": "/html-to-image/static-1.38",
  "laboratory-lib": "/laboratory-lib/static-3.6555",
  "zustand": "/zustand/static-1.51",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.7352",
  "hs-entities": "/hs-entities/static-1.11",
  "batch-promise": "/batch-promise/static-1.962",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3486",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6166",
  "persist-promise": "/persist-promise/static-1.3120",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.15898",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.19964",
  "lodash": "/lodash/static-4.7",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.381",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5017",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7171",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.11783",
  "idb-keyval": "/idb-keyval/static-1.29",
  "reactive-lib": "/reactive-lib/static-1.108",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "audio-components": "/audio-components/static-1.5145",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.34982",
  "urlinator": "/urlinator/static-1.3908",
  "video-components": "/video-components/static-1.11473",
  "video-embed": "/video-embed/static-1.33962",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3024",
  "onboarding-scopes": "/onboarding-scopes/static-1.5882",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5104",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4491",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3036",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.20705",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.16916",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.35360",
  "crm_components": "/crm_components/static-3.90032",
  "crm_data": "/crm_data/static-4.90032",
  "customer-data-tracking": "/customer-data-tracking/static-1.6216",
  "framework-data-table": "/framework-data-table/static-2.10557",
  "browser-eslint": "/browser-eslint/static-2.57",
  "hub-http-contrib": "/hub-http-contrib/static-1.2468",
  "interframe": "/interframe/static-3.4129",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4570",
  "layout-dnd-components": "/layout-dnd-components/static-1.11378",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10353",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.12279",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8617",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10440",
  "calling-error-reporting": "/calling-error-reporting/static-1.30667",
  "worker-connection-library": "/worker-connection-library/static-1.15921",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.5865",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.33592",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.8862",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.4716",
  "fsm": "/fsm/static-1.3062",
  "policy-lib": "/policy-lib/static-1.6128",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.8626",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.9724",
  "content-media-compositions": "/content-media-compositions/static-2.13731",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7120",
  "react-transition-group": "/react-transition-group/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8118",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.26780",
  "knowledge-content-types": "/knowledge-content-types/static-1.8041",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2326",
  "automation-templates-service-types": "/automation-templates-service-types/static-1.3317",
  "automation-ui-core": "/automation-ui-core/static-2.19830",
  "automation-ui-routing": "/automation-ui-routing/static-1.19253",
  "automation-ui-usage-tracker": "/automation-ui-usage-tracker/static-1.512",
  "final-form": "/final-form/static-1.53",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "form-builder-ui": "/form-builder-ui/static-1.8594",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3103",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2416",
  "social-insights-client-types": "/social-insights-client-types/static-1.20339",
  "outpost": "/outpost/static-1.3683",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4002",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5866",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.16409",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.6524",
  "customer-data-associations": "/customer-data-associations/static-1.6599",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.17447",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.8948",
  "crm_universal": "/crm_universal/static-1.21182",
  "customer-data-content": "/customer-data-content/static-1.26121",
  "crm_schema": "/crm_schema/static-3.90071",
  "customer-data-email": "/customer-data-email/static-1.16962",
  "layout-data-lib": "/layout-data-lib/static-1.8678",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.33817",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3147",
  "sales-views-client-types": "/sales-views-client-types/static-1.3626",
  "trellis-story-utils": "/trellis-story-utils/static-1.3913",
  "storybook-react": "/storybook-react/static-1.16",
  "hls.js": "/hls.js/static-1.24",
  "js-cookie": "/js-cookie/static-1.18",
  "immutable-less": "/immutable-less/static-1.3930",
  "usage-tracker-hubtools": "/usage-tracker-hubtools/static-1.6786",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.9720",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.15282",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.17875",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7422",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3407",
  "stripe-connect-js": "/stripe-connect-js/static-1.43",
  "utility-belt": "/utility-belt/static-1.1863",
  "customer-data-rte": "/customer-data-rte/static-1.31578",
  "cv-backend-services": "/cv-backend-services/static-1.1349",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.4887",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.13250",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4437",
  "qrcode-generator": "/qrcode-generator/static-1.52",
  "quotes-client-types": "/quotes-client-types/static-1.35899",
  "trials-service-types": "/trials-service-types/static-1.3424",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8184",
  "sequences-lib": "/sequences-lib/static-1.7132",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.9601",
  "apps-service-types": "/apps-service-types/static-1.3350",
  "oauth-service-types": "/oauth-service-types/static-1.3610",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.6746",
  "nav-meta": "/nav-meta/static-1.27862",
  "react-window": "/react-window/static-1.13",
  "draft-content-plugins": "/draft-content-plugins/static-1.26926",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-2.46",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.20601",
  "FireAlarmUi": "/FireAlarmUi/static-1.4034",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3596",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.6989"
}
};
